import { render, staticRenderFns } from "./oldDetailList.vue?vue&type=template&id=053d0bee&scoped=true&"
import script from "./oldDetailList.vue?vue&type=script&lang=js&"
export * from "./oldDetailList.vue?vue&type=script&lang=js&"
import style0 from "./oldDetailList.vue?vue&type=style&index=0&id=053d0bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d0bee",
  null
  
)

export default component.exports